import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import RegistrationCivilUnionNonResidentNotificationShared from 'shell/components/shared/research-notifications/research-civil-union-non-resident/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface ResearchCivilUnionDetailNotificationsPageProps {
  scope?: string;
  isOther?: boolean;
  items?: BreadcrumbItem[];
}

const RegistrationCivilUnionNonResidentDetailNotificationCivilStatusShared = ({
  scope,
  isOther,
  items,
}: ResearchCivilUnionDetailNotificationsPageProps): ReactElement => {
  const params = useParams();

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;
  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const editSipoUrl = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR/persona-sipo`;
  }, [goBackUrl]);

  const goBackUrlPage = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <RegistrationCivilUnionNonResidentNotificationShared
        editSipoUrl={editSipoUrl}
        goBackUrl={goBackUrlPage}
        goBackUrlDetail={goBackUrlDetail}
        isOther={isOther}
        items={items}
      />
    </Fragment>
  );
};

RegistrationCivilUnionNonResidentDetailNotificationCivilStatusShared.displayName =
  'Research CivilUnion Detail Notifications Page component';

export default RegistrationCivilUnionNonResidentDetailNotificationCivilStatusShared;
